'use client'

export default function BlogError({ reset }: { reset: () => void }) {
  return <main id="main-content" className="wrap blog-error" dir="rtl">
    <h1>تعذّر تحميل المقالات الآن</h1>
    <p>قد يكون مصدر المحتوى غير متاح مؤقتًا. أعد المحاولة بعد قليل.</p>
    <button type="button" onClick={reset} className="btn btn-primary">إعادة المحاولة</button>
  </main>
}
